export const GUTTER_SIZE_IN_PX = 120; // Default gutter size
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/**
 * @deprecated - [ED-23844] only used in Editor Core
 */
export const GUTTER_SIZE_MOBILE_IN_PX = 36; // Gutter size for Mobile
export const GUTTER_SELECTOR = '#editor-scroll-gutter';
